export var RoomStatus;
(function (RoomStatus) {
    RoomStatus["joining"] = "joining";
    RoomStatus["starting"] = "starting";
    RoomStatus["active"] = "active";
    RoomStatus["ended"] = "ended";
    RoomStatus["leaving"] = "leaving";
})(RoomStatus || (RoomStatus = {}));
